import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_male",
  "use": "icon-icon_male-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_male\"><defs><style></style></defs><path d=\"M944.947 55.296H666.624a25.6 25.6 0 1 0 0 51.2h216.474L630.988 358.81a351.027 351.027 0 1 0 35.84 36.454l252.52-251.904v215.86a25.6 25.6 0 0 0 51.2 0V81.92a25.6 25.6 0 0 0-25.6-26.624zM478.413 907.264a296.96 296.96 0 1 1 209.92-363.52 297.78 297.78 0 0 1-209.92 363.52z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol